import React, { useState } from 'react';
import './PopupContent.scss';

function PopupPOI(props) {
  return (
    <div className='DanonePopupTerritory__popup'>
      <div className='header'>
        <div className='wrapper-title'>
          <div className='title' title={props.properties?.name}>
            {props.properties?.name}
          </div>
          <div className='subtitle'>{`${props.properties?.latitude}, ${props.properties?.longitude}`}</div>
        </div>
      </div>
      <div className='detail'>
        <div>ID Outlet</div>
        <div>{props.properties?.id_outlet}</div>
      </div>
      <div className='detail'>
        <div>Distributor</div>
        <div>{props?.properties?.distributor}</div>
      </div>
      <div className='detail'>
        <div>Depo</div>
        <div style={{ userSelect: 'text' }}>{props.properties?.depo}</div>
      </div>
      <div className='detail'>
        <div>Telp</div>
        <div style={{ userSelect: 'text' }}>{props.properties?.telpon}</div>
      </div>
      <div className='detail' style={{ alignItems: 'flex-start' }}>
        <div>Address</div>
        <div
          className='address'
          style={{ userSelect: 'text' }}
          title={props.properties?.address}
        >
          {props.properties?.address}
        </div>
      </div>
      <div className='detail'>
        <div>Village</div>
        <div style={{ userSelect: 'text' }}>{props.properties?.village}</div>
      </div>
      <div className='detail'>
        <div>District</div>
        <div style={{ userSelect: 'text' }}>{props.properties?.district}</div>
      </div>
      <div className='detail'>
        <div>City</div>
        <div style={{ userSelect: 'text' }}>{props.properties?.city}</div>
      </div>
      <div className='detail'>
        <div>Category</div>
        <div style={{ userSelect: 'text' }}>{props.properties?.category}</div>
      </div>
      {props.click && (
        <a className='button' href={props?.href} target='_blank' type='button'>
          Area Profiling
        </a>
      )}
    </div>
  );
}

function PopupGeojsonTerritory(props) {
  const [showMore, setShowMore] = useState(false);
  const [animationClass, setAnimationClass] = useState('');

  const handleToggleShow = () => {
    if (showMore) {
      setAnimationClass('animate-out');
      setTimeout(() => {
        setShowMore(false);
        setAnimationClass('');
      }, 300);
    } else {
      setShowMore(true);
      setAnimationClass('animate-in');
      setTimeout(() => {
        setAnimationClass('');
      }, 300);
    }
  };

  return (
    <div className='DanonePopupTerritory__popup'>
      <div className='header'>
        <div className='wrapper-title'>
          <div className='title' title={props.properties?.name}>
            {props.properties?.name}
          </div>
        </div>
      </div>
      <div className='detail'>
        <div>Cluster ID :</div>
        <div>{props.properties?.cluster_id}</div>
      </div>
      <div className='detail'>
        <div>Coverage Area :</div>
        <div>{props.properties?.coverage}</div>
      </div>
      <div className='detail'>
        <div>Village :</div>
        <div>{props.properties?.nama_desa}</div>
      </div>
      <div className='detail' style={{ alignItems: 'flex-start' }}>
        <div>Center :</div>
        <div className='address' style={{ userSelect: 'text' }}>
          {props.properties?.center}
        </div>
      </div>
      <div className='detail'>
        <div>Total AHS :</div>
        <div>{props.properties?.total_ahs}</div>
      </div>
      <div className='detail'>
        <div>Class :</div>
        <div>{props.properties?.class}</div>
      </div>
      <div className='detail'>
        <div>SES-AB :</div>
        <div>{props.properties?.ses_ab}</div>
      </div>
      <div className='detail'>
        <div>SES-BC :</div>
        <div>{props.properties?.ses_bc}</div>
      </div>
      <div className='detail'>
        <div>SES-CD :</div>
        <div>{props.properties?.ses_cd}</div>
      </div>
      <div className='detail'>
        <div>Total Household :</div>
        <div>{props.properties?.total_household}</div>
      </div>
      <div className='detail'>
        <div>Village Code :</div>
        <div>
          <div
            className={`village_code ${animationClass}`}
            style={{
              userSelect: 'text',
              maxHeight: showMore ? '100rem' : '5.8rem',
            }}
          >
            {props.properties?.village_code}
          </div>
          {props.click && props.properties?.village_code_length > 5 && (
            <a
              className='expand'
              onClick={handleToggleShow}
              type='button'
            >
              Show {showMore ? 'less' : 'more'}
            </a>
          )}
        </div>
      </div>
      {props.click && (
        <a className='button' href={props?.href} target='_blank' type='button'>
          Area Profiling
        </a>
      )}
    </div>
  );
}

function PopupGeojsonArea(props) {
  return (
    <div className='DanonePopupTerritory__popup'>
      <div className='header'>
        <div className='wrapper-title'>
          <div className='title' title={props.properties?.name}>
            {props.properties?.name}
          </div>
        </div>
      </div>
      <div className='detail'>
        <div>{props.properties?.area?.key} :</div>
        <div>{props.properties?.area?.value}</div>
      </div>
      <div className='detail'>
        <div>Coverage :</div>
        <div>{props.properties?.coverage}</div>
      </div>
    </div>
  );
}

/**
 *
 * @param {object} props
 * @param {'poi' | 'geojson'} props.type
 * @param {object} props.properties
 * @param {boolean} props.click
 * @param {string} props.href
 * @returns
 */
export default function PopupContent(props) {
  const { type, properties, click, href } = props;
  switch (type) {
    case 'poi':
      return <PopupPOI click={click} href={href} properties={properties} />;
    case 'territory':
      return (
        <PopupGeojsonTerritory
          click={click}
          href={href}
          properties={properties}
        />
      );
    case 'area':
      return <PopupGeojsonArea properties={properties} />;
    default:
      return null;
  }
}
